import { useState,useEffect } from 'react'
import ReactApexCharts from 'react-apexcharts'
import { getCSSVariableValue } from '../../../../../_metronic/assets/ts/_utils';
import { ApexOptions } from "apexcharts";
import { KTIcon } from '../../../../../_metronic/helpers';



function dosDecimales(n:any) {
    let t=n.toString();
    let regex=/(\d*.\d{0,2})/;
    return t.match(regex)[0];
  }

export default function Througputchart(props:{total:number, exedido:number, name:string,disponible: number, className: string, chartColor: string, chartHeight: number}) {
    const baseColor = getCSSVariableValue('--bs-' + props.chartColor)
    const lightColor = getCSSVariableValue('--bs-' + props.chartColor + '-light')
    const labelColor = getCSSVariableValue('--bs-gray-700')

const options: ApexOptions = {
        chart: {
            fontFamily: 'inherit',
            height: props.chartHeight,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: '65%',
              },
              dataLabels: {
                name: {
                  show: true,
                  fontWeight: '100',
                },
                value: {
                  color: labelColor,
                  fontSize: '20px',
                  fontWeight: '700',
                  offsetY: 12,
                  show: true,
                  formatter: function (val:any) {
                    return val + '%'
                  },
                },
              },
              track: {
                background: lightColor,
                strokeWidth: '100%',
              },
            },
          },
          colors: [baseColor],
          stroke: {
            lineCap: 'butt',
          },
          labels: ['Available'],
    }

   
 const [prueba, setprueba] = useState({
          
    series: [Number(dosDecimales((props.disponible/props.total)*100))],
            
})

useEffect( () => {
    setprueba({ series: [Number(dosDecimales((props.disponible/props.total)*100))]})
    
 }, [props.disponible , props.total])





    return(
        <div className="card  card-custom 0  border border-gray-300 card-xxl-stretch mb-5 mb-xl-10 ">
          <div className='card-header text-center'>
                
                 <h4 className="card-title text-center ">It has a total of {props.total} Mbps throughput to distribute in its connectors.</h4> 
          </div>
            <div className='card-body '>
                 <ReactApexCharts options={options} series={prueba.series} type="radialBar" height={props.chartHeight} />

            </div>
            

            
            {props.exedido <=props.total&&<div className='card-footer text-center'>
              <strong className='text-info'> {props.disponible}</strong>  Mbps throughput available 
            </div>
            }
            {props.exedido > props.total&&
            <div className='card-footer text-center'>
              <strong className='text-danger'> {props.exedido-props.total}</strong>  Mbps throughput Exceeded. Please remove any connector or upgrade your plan
            </div>}
        </div>
    )
}